import React, { Fragment } from 'react';
import classnames from 'classnames';
import fr from 'facet-rest';
import { useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import PropTypes from 'prop-types';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import useBackgroundColor from 'Hooks/useBackgroundColor';
import StatusBanner from 'Components/StatusBanner';
import Dashboard from './Dashboard';
import Demographics from './Demographics';
import './index.css';


function LandingPage({ match }) {
  const {
    params: { 1: additional },
  } = match;
  // Hack: We have 2 contexts.  Show a loading overlay while the 2 sync.  Once the household ids match remove the overlay

  const { householdResource } = useSimpleHousehold();
  const { rootNodeProps } = useEventTrackingLogEvent({
    nodeName: 'Landing Page',
    isPageView: true,
  });

  const theme = useTheme();
  useBackgroundColor(theme.palette.facet.lightGray);

  return (
    <Fragment>
      <div
        className="advisor-household-landingpage"
        {...rootNodeProps}
      >
        <div
          className={classnames({
            dashboard: true,
            'timeline-dashboard': additional === '/timeline',
          })}
        >
          <div className="dashboard-content">
            {householdResource ? <StatusBanner resourceLink={householdResource.relationship(fr.relationships.statusBanners.name)?.link('related')} /> : null}
            <div className="dashboard-header">
              <div>
                <Demographics />
              </div>
            </div>
            <div className="dashboard-body">
              <Dashboard />
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

LandingPage.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.object,
  }).isRequired,
};

export default LandingPage;
